






































import { Type, NoExpression, Expression, UpdateExpression, Types, PathExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';


export default ExpressionBase<UpdateExpression>().extend({
  name: 'UpdateEditor',
  computed: {
    valueType(): Type | null {
      return Types.simplify(this.value.path.getType(this.registry.defs, this.context));
    },
    valueContext(): Type {
      return this.valueType
        ? this.registry.defs.getContext(this.context, {
            [this.value.currentVariable]: this.valueType,
          })
        : this.context;
    },
  },
  methods: {
    clearValue() {
      this.value.value = NoExpression.instance;
      this.update();
    },
    setValue(value: Expression) {
      this.value.value = value;
      this.update();
    },
    clearPath() {
      this.value.path.expressions = [NoExpression.instance];
      this.update();
    },
    setPath(path: PathExpression) {
      this.value.path = path;
      this.update();
    },
  },
});
